import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { lessonActions } from "../../../store/lesson-slice";
import { ApplicationApi, lessonsApi, sendMessageToServiceWorker, studyGroupsApi } from '../../../utils'
import { throwApiError } from "../store/error-handling-actions";
import classes from './LessonViewer.module.css'
import editIconWhite from '../assests/edit-icon-white.png'
import editIconBlack from '../assests/edit-icon-black.png'
import LearningLesson from "./Tabs/Learning/LearningLesson";
import fileTextIconWhite from '../assests/fileText-icon-white.png'
import fileTextIconBlack from '../assests/fileText-icon-black.png'
import CommunicationTeacher from "./Chat/CommunicationTeacher";
import AssessmentAndSubmission from "./Tabs/AssessmentAndSubmission/AssessmentAndSubmission";
import HeaderLessonViewer from "./Header/HeaderLessonViewer";
import LessonViewerTabs from "./Tabs/LessonViewerTabs";
import ReflectionAnswers from "./ReflectionAnswers/ReflectionAnswers";
import { useNavigate, useParams } from "react-router-dom";
import * as PathRouter from '../../../models/PathRoute'
import DynamicMessage from "../UI/Popups/DynamicMessage/DynamicMessage";
import { DynamicMessageTypeEnum } from "../models/DynamicMessageTypeEnum";
import { ControlRequestTypeEnum } from "../models/ControlRequestTypeEnum";
import { sendControlRequest, sendMessageToTeam, updateMessageProperty, updateReadenMessage } from "../store/signalRMessages-actions";

const LessonViewer = ({ backUrl, handleCloseCallBack, teacherMode, lessonId, ProjectsComm, studyGroupId, saveProjectCallback, shareBtn, setPopUpSize, onlyView, selectedAssessmentId, showClosePopup, showCloseIcon }) => {

    const dispatch = useDispatch();
    const texts = useSelector(state => state.translate.texts);
    const applicationId = useSelector(state => state.application.applicationId);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const { lesson } = useSelector(state => state.lessons);
    const token = useSelector(state => state.signalRMessages?.token);
    const messages = useSelector(state => state.signalRMessages?.messages);
    const user = useSelector((state) => state.auth.user);
    const uiData = useSelector((state) => state.general.uiData);
    const navigate = useNavigate();
    const [currentContentIndex, setCurrentContentIndex] = useState(0);
    const [loader, setLoader] = useState(true);
    const [data, setData] = useState()
    const [showChat, setShowChat] = useState(false)
    const [showReflection, setShowReflection] = useState(false)
    const [scoreByRetries, setScoreByRetries] = useState([])
    const [jumpToQuestion, setJumpToQuestion] = useState(false)
    const [message, setMessage] = useState(null)
    const [sentRequest, setSentReqest] = useState(false)
    const [askControl, setAskControl] = useState(false)
    const timeoutRef = useRef(null);
    const LessonWidth = useRef()
    const MYLESSONWIDTH = 1040
    const btnList = [
        { component: LearningLesson, iconWhite: fileTextIconWhite, iconBlack: fileTextIconBlack, text: 'learning' },
        { component: AssessmentAndSubmission, iconWhite: editIconWhite, iconBlack: editIconBlack, text: 'assessmentAndSubmission', shareBtn: shareBtn },
    ]

    useEffect(() => {
        if (LessonWidth?.current?.offsetWidth > MYLESSONWIDTH)
            setShowChat(true)
    }, [])

    useEffect(() => {
        if (applicationId)
            ApplicationApi.applicationsFilterIdPost(applicationId, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: texts.MessageTitleMessagesSetReadRange, error: error, statusCode: response?.statusCode, message: "applicationsFilterIdPost " + error.message, level: 2, component: "LessonViewer", line: 43 }))
                }
                else {
                    setScoreByRetries(JSON.parse(resdata.contentData)?.ScoreByRetries || [])
                }
            })
    }, [applicationId])

    useEffect(() => {
        if (sentRequest && askControl && homeUrl) {
            timeoutRef.current = setTimeout(() => {
                if (timeoutRef.current && timeoutRef.current !== null) {
                    sendControlRequest(token, ControlRequestTypeEnum.GiveControl, messages[messages?.length - 1]?.userFrom, lessonId, user, studyGroupId, setMessage,
                        <DynamicMessage type={DynamicMessageTypeEnum.Warn} title={texts.editTaskConfirmationReceived} showCancel={false} confirmText={texts.ok}
                            confirmFunc={() => {
                                setMessage(null);
                                dispatch(updateReadenMessage(true));
                            }} />,
                        messages, dispatch);
                    getLessonData()
                }
            }, 10000);
        }
    }, [sentRequest, askControl, homeUrl]);

    useEffect(() => {
        clearTimeout(timeoutRef.current);
    }, [messages]);

    useEffect(() => {
        if (uiData && uiData.BlockingTeamwork && homeUrl) {
            setMessage(null);
            const latestMessage = messages[messages?.length - 1];
            switch (latestMessage?.message) {
                case ControlRequestTypeEnum.SendControlRequest:
                    if (lessonId === latestMessage?.lessonId && latestMessage?.givenControl) {
                        dispatch(updateReadenMessage(true))
                        dispatch(updateMessageProperty(false));
                        navigate(`${homeUrl}/${studyGroupId}/dashboard`);
                        setMessage(null)
                    }
                    else {
                        if (!window.location.pathname.includes('project') && !latestMessage?.isRead) {
                            setMessage(<DynamicMessage type={DynamicMessageTypeEnum.Warn} title={texts.teamMemberEditRequestConfirmation} cancelText={texts.reject}
                                cancelFunc={() => {
                                    dispatch(updateReadenMessage(true))
                                    dispatch(updateMessageProperty(false));
                                    sendMessageToTeam(token, ControlRequestTypeEnum.Reject, latestMessage?.userFrom, null, user, null, setMessage, null);
                                }}
                                confirmText={texts.giveControl}
                                confirmFunc={() => {
                                    dispatch(updateReadenMessage(true))
                                    sendControlRequest(token, ControlRequestTypeEnum.GiveControl, messages[messages?.length - 1]?.userFrom, null, user, null, setMessage, null, messages, dispatch);
                                    navigate(`${homeUrl}/${studyGroupId}/dashboard`);
                                }} />);
                        }
                    }
                    break;
                case ControlRequestTypeEnum.GiveControl:
                    if (!latestMessage?.isRead) {
                        setMessage(<DynamicMessage type={DynamicMessageTypeEnum.Warn} title={texts.editTaskConfirmationReceived} showCancel={false} confirmText={texts.ok}
                            confirmFunc={() => {
                                setMessage(null);
                                dispatch(updateReadenMessage(true));
                            }} />);
                        getLessonData();
                    }
                    break;
                case ControlRequestTypeEnum.Reject:
                    if (!latestMessage?.isRead) {
                        setMessage(<DynamicMessage type={DynamicMessageTypeEnum.Warn} title={texts.editTaskConfirmationRejected} showCancel={false} confirmText={texts.ok}
                            confirmFunc={() => {
                                dispatch(updateReadenMessage(true));
                                setMessage(null);
                                navigate(`${homeUrl}/${studyGroupId}/dashboard`);
                            }} />);
                    }
                    break;
                case ControlRequestTypeEnum.GetControlRequest: setMessage(<DynamicMessage type={DynamicMessageTypeEnum.Warn} title={texts.sentRequest} showCancel={false} confirmText={texts.cancel}
                    confirmFunc={() => {
                        navigate(`${homeUrl}/${studyGroupId}/dashboard`);
                    }} />);
                    break;
                default:
                    break;
            }
        }
    }, [messages, uiData, homeUrl]);

    useEffect(() => {
        if (homeUrl)
            getLessonData()
    }, [texts, lessonId, homeUrl])

    const initLessonData = (res) => {
        setData({ ...res, studyGroupId });
        dispatch(lessonActions.setLesson({ lesson: res }));
    }

    const hundleShowLessonQuestion = () => {
        setCurrentContentIndex(0)
        setJumpToQuestion(true)
    }

    const startedLesson = (lessonId, lockedByUserId) => {
        let myMessage = <DynamicMessage
            type={DynamicMessageTypeEnum.Warn}
            title={texts.sentRequest}
            showCancel={false}
            confirmText={texts.cancel}
            confirmFunc={() => { navigate(`${homeUrl}/${studyGroupId}/dashboard`) }} />

        setMessage(<DynamicMessage
            type={DynamicMessageTypeEnum.Warn}
            title={texts.LessonInEditByTeamMember}
            cancelFunc={() => {
                setMessage(null);
                navigate(`${homeUrl}/${studyGroupId}/dashboard`);
            }}
            confirmText={texts.TransferControl}
            confirmFunc={() => {
                setAskControl(true)
                sendMessageToTeam(token, ControlRequestTypeEnum.SendControlRequest, lockedByUserId, lessonId, user, studyGroupId, setMessage, myMessage);
                setSentReqest(true)
            }} />);
    }

    const getLessonData = () => {
        if (!lessonId || lessonId == "0")
            return;
        let data = {
            id: lessonId,
            studyGroupId: studyGroupId
        }
        lessonsApi.lessonsFilterPost({ lessonFilter: data }, (error, resdata, response) => {
            if (error) {
                let txt = texts.lessonsFilterError;
                if (error.status == 403) {
                    if (error?.response?.body?.code == 101) {
                        studyGroupsApi.studyGroupsFilterIdPost(studyGroupId, (error, resdata, response) => {
                            if (error) {
                                dispatch(throwApiError({ userMessage: texts.studyGroupsFilterError, error: error, statusCode: response?.statusCode, message: "studyGroupsFilterRangePost " + error.message, level: 1, component: "course-actions", line: 28 }))
                            }
                            else {
                                navigate(`${homeUrl}/connect/${resdata.courseId}/${resdata.id}`,
                                    { state: { navigateToUrl: `${homeUrl}/${resdata.id}/${PathRouter.LESSON}/${lessonId}` } })
                            }
                        })
                    }
                    if (error?.response?.body?.code == 413) {
                        setMessage(null);
                        startedLesson(lessonId, error?.response?.body?.data?.lockedByUserExternalId)
                    }
                }
                else {
                    dispatch(throwApiError({ userMessage: txt, error: error, statusCode: response?.statusCode, message: "lessonsFilterPost " + error.message, level: 2, component: "LessonViewer", line: 23 }))
                    setData(null)
                }
            }
            else {
                if ('serviceWorker' in navigator) {
                    const allUserIds = response.body?.lessonParticipant?.user?.users?.map(u => u.id !== user.id ? u.id : null).filter(Boolean);
                    sendMessageToServiceWorker('filterLessonData', {
                        users: allUserIds,
                        apiUrl: window.config
                    });
                }
                initLessonData(response.body);
            }
        })
    }

    return (
        <div className={classes.LessonViewerContainer} ref={LessonWidth}>
            <HeaderLessonViewer
                backUrl={backUrl}
                btnList={btnList}
                data={data}
                handleCloseCallBack={handleCloseCallBack}
                setLoader={setLoader}
                currentContentIndex={currentContentIndex}
                setCurrentContentIndex={setCurrentContentIndex}
                setJumpToQuestion={setJumpToQuestion}
                setShowChat={() => { setShowChat(prev => !prev) }}
                displayIconChatStyle={'flex'}
                showChat={showChat}
                showClosePopup={showClosePopup}
                showCloseIcon={showCloseIcon}>
            </HeaderLessonViewer>

            <div className={classes.LessonViewerTabsContainer}>
                <LessonViewerTabs
                    selectedAssessmentId={selectedAssessmentId}
                    btnList={btnList}
                    teacherMode={teacherMode}
                    ProjectsComm={ProjectsComm}
                    studyGroupId={studyGroupId}
                    saveProjectCallback={saveProjectCallback}
                    shareBtn={shareBtn}
                    onlyView={onlyView}
                    data={data}
                    setData={setData}
                    loader={loader}
                    jumpToQuestion={jumpToQuestion}
                    currentContentIndex={currentContentIndex}
                    setShowReflection={setShowReflection}
                    hundleShowLessonQuestion={hundleShowLessonQuestion}
                    scoreByRetries={scoreByRetries}
                    widthAssessmentStyle={LessonWidth?.current?.offsetWidth < MYLESSONWIDTH ? 'calc(100% - 23px - 23px)' : showChat ? 'calc(100% - 296px - 23px - 23px - 23px)' : 'calc(100% - 23px - 23px - 23px)'}>
                </LessonViewerTabs>

                {showChat &&
                    <CommunicationTeacher
                        data={data}
                        positionStyle={LessonWidth?.current?.offsetWidth < MYLESSONWIDTH ? 'absolute' : ''} >
                    </CommunicationTeacher>
                }
                {showReflection &&
                    <ReflectionAnswers
                        setShowReflection={setShowReflection}
                        lessonId={lessonId}
                        studyGroupId={studyGroupId} />
                }

            </div>
            {message}
        </div >
    )
}

export default LessonViewer